import React, { useEffect, useRef, useState, useMemo } from "react";
import PageTable from "@/components/i-pageTable/i-pageTable";
import PageTab from "@/components/i-pageTab/i-pageTab";

import {
  getRewardConfigList,
  addRewardConfig,
  editRewardConfig,
  deleteRewardConfig,
  getRewardConfigDetail,
} from "@/api/shopping";
import { Button, message, Modal, Space, Tag, Image } from "antd";
import {
  resetForm,
  setIcons,
  downloadFile,
  getTimeFormat,
} from "@/utils/common";

import { useSelector, useDispatch, useStore } from "react-redux";
import { dictInfoAsync } from "@/stores/dictInfo";
import { columns, formTab, modalFormTab } from "./helps";
import { appUserBaseList } from "@/api/index";

export default function CommissionManager() {
  // const dispatch = useDispatch();
  // const {
  //   state: { approval_state, card_type, ns_channel_type },
  // } = useSelector((state: { dictInfo: any }) => state.dictInfo);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [renterOpen, setRenterOpen] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [userList, setUserList] = useState<any[]>([]);
  const [deviceFlowRewardType, setDeviceFlowRewardType] = useState<number>(0);

  const [pageData, setPageData] = useState<
    SelectCmsUserCashOrderPageRes["rows"]
  >([]);
  const [formData, setFormData] = useState<any>({
    endTime: "",
    startTime: "",
    ypageNum: 1,
    ypageSize: 10,
    delFlag: 0,
  });
  const [modalFormData, setModalFormData] = useState<any>({});

  const footer = [
    {
      title: "新增",
      icon: setIcons("PlusOutlined"),
      onClick: () => setOpen(true),
      loading: exportLoading,
    },
  ];

  const getUserList = async (val: string) => {
    const res = await appUserBaseList({ mobile: val });
    setUserList(
      res.data.map((item: any) => ({
        label: `${item.nickName}（${item.mobile}）`,
        value: item.userId,
      }))
    );
  };
  // useEffect(() => {
  //   getUserList("");
  // }, []);

  useEffect(() => {
    getPageData();
  }, [formData]);

  const getPageData = async () => {
    setLoading(true);
    try {
      const data = await getRewardConfigList(formData);
      setPageData(data.rows);
      setTotal(data.total);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const search = (val: any) => {
    setFormData({ ...formData, ...val, ypageNum: 1 });
  };

  const pageChange = (current: number, pageSize: number) => {
    setFormData({
      ...formData,
      ypageNum: current,
      ypageSize: pageSize,
    });
  };

  const confirmData = async (val: any) => {
    // console.log(val);
    if (val.deviceFlowRewardType === 1) {
      if (Number(val.deviceFlowRewardMin) > Number(val.deviceFlowRewardMax)) {
        message.error("流水最小值不能大于流水最大值");
        return;
      }
    }

    try {
      if (modalFormData.id) {
        await editRewardConfig({
          ...modalFormData,
          ...val,
        });
      } else {
        await addRewardConfig(val);
      }
      message.success("分佣配置成功");
      getPageData();
      closeModal();
    } catch (error) {}
  };

  const reset = () => {
    setFormData({
      ...resetForm(formData),
      delFlag: 0,
    });
  };

  const deleteCommissionData = async (id: string) => {
    try {
      Modal.confirm({
        title: "确定删除该分佣配置吗？",
        onOk: async () => {
          await deleteRewardConfig(id);
          message.success("已删除");
          getPageData();
        },
      });
    } catch (error) {}
  };

  const closeModal = () => {
    setOpen(false);
    setDeviceFlowRewardType(0);
    setUserList([]);
    setModalFormData({});
  };

  const editCommissionData = async (val: any) => {
    try {
      const { data } = await getRewardConfigDetail(val.id);
      console.log('编辑时获取的数据:', data);
      console.log('编辑时设置的 deviceFlowRewardType:', data.deviceFlowRewardType);
      setDeviceFlowRewardType(data.deviceFlowRewardType);
      setModalFormData(data);
      getUserList(data.userId);
      setOpen(true);
    } catch (error) {
      console.error('获取编辑数据失败:', error);
    }
  };

  // 使用 useMemo 缓存 modalFormTab，避免每次渲染都重新创建导致表单重置
  const memoizedModalFormTab = useMemo(() => {
    return modalFormTab(
      setDeviceFlowRewardType,
      deviceFlowRewardType,
      userList,
      getUserList
    );
  }, [setDeviceFlowRewardType, deviceFlowRewardType, userList, getUserList]);

  return (
    <div>
      <Modal
        destroyOnHidden
        open={open}
        title={modalFormData.id ? "编辑分佣配置" : "新增分佣配置"}
        width="480px"
        footer={<></>}
        onCancel={closeModal}
      >
        <PageTab
          subFoot
          search={confirmData}
          reset={closeModal}
          initialValues={modalFormData}
          formTab={memoizedModalFormTab}
        ></PageTab>
      </Modal>
      <PageTab
        defaultTimer={[]}
        reset={reset}
        search={search}
        formTab={formTab}
        footer={footer}
      ></PageTab>
      <PageTable
        loading={loading}
        rowKey="id"
        pageChange={pageChange}
        data={pageData}
        columns={columns({
          setModalFormData,
          setOpen,
          deleteCommissionData,
          editCommissionData,
        })}
        pagination={{
          total: total,
          current: formData.ypageNum,
        }}
      ></PageTable>
    </div>
  );
}
